export default {
  namespaced: true,

  state: {},

  getters: {},

  mutations: {
    SET_OBJECT(state, [namespace, data]) {
      state[namespace] = { ...data };
    },
    SET_ARRAY(state, [namespace, data]) {
      state[namespace] = [...data];
    }
  },

  actions: {}
};
